import { Component, inject, input, signal } from "@angular/core";
import { ItemMenu, NavBarService } from "@app/layouts/nav-bar/nav-bar.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { OverlayModule } from "@angular/cdk/overlay";
import { NgClass } from "@angular/common";
import { PopupMinimizedNavBarComponent } from "@app/layouts/nav-bar/popup-minimized-nav-bar/popup-minimized-nav-bar.component";
import { animate, style, transition, trigger } from "@angular/animations";
import { TranslateModule } from "@ngx-translate/core";
import { DxSharedModule } from "@app/shared/dx-shared.module";

@Component({
  selector: "app-item-link-nav-bar",
  standalone: true,
  imports: [
    RouterLinkActive,
    OverlayModule,
    NgClass,
    RouterLink,
    PopupMinimizedNavBarComponent,
    TranslateModule,
    DxSharedModule,
  ],
  templateUrl: "./item-link-nav-bar.component.html",
  styleUrl: "./item-link-nav-bar.component.scss",
  animations: [
    trigger("popup2", [
      transition(":enter", [
        style({ opacity: 0, transform: "translateY(-10px)" }),
        animate(
          "200ms ease-out",
          style({ opacity: 1, transform: "translateY(0)" })
        ),
      ]),
      transition(":leave", [
        animate(
          "150ms ease-in",
          style({ opacity: 0, transform: "translateY(-10px)" })
        ),
      ]),
    ]),
  ],
})
export class ItemLinkNavBarComponent {
  public readonly listItem = input.required<ItemMenu>();
  protected readonly subItemsPopupOpen = signal<boolean>(false);
  private readonly mainLayoutService = inject(NavBarService);
  protected readonly isMinimized =
    this.mainLayoutService.getSignalIsMinimized();
  protected readonly positions = this.mainLayoutService.positions;

  public constructor() {
    this.mainLayoutService.closeAllPopups$
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.closeSubItemsPopup();
      });
  }

  protected getColorIcon(rla: RouterLinkActive): string {
    return rla.isActive ? "#fff" : "var(--blue-text)";
  }

  protected onMouseEnterInLink(): void {
    if (this.isMinimized()) {
      this.mainLayoutService.closeAllPopups();
      this.subItemsPopupOpen.set(true);
    }
  }

  protected closeSubItemsPopup(): void {
    this.subItemsPopupOpen.set(false);
  }
}
